module.exports = __webpack_public_path__ + "static/media/car-card-pickup.6b519360.svg";